import React, { createContext, useState, useEffect } from "react";
import getTheme from "../theme";

export const ThemeContext = createContext();

export const defaultTheme = {
  mode: "light",
  primary: "#8C57FF", // Default primary color
  secondary: "#8A8D93", // Default secondary color
  fontFamily: "Roboto, Arial", // Default font
};

export const ThemeProvider = ({ children }) => {
    // const defaultTheme = {
    //     mode: "light",
    //     primary: "#8C57FF", // Default primary color
    //     secondary: "#8A8D93", // Default secondary color
    //     fontFamily: "Roboto, Arial", // Default font
    //   };

  const storedTheme = JSON.parse(localStorage.getItem("themeOptions")) || defaultTheme;

  const [themeOptions, setThemeOptions] = useState(storedTheme);

  const updateTheme = (newOptions) => {
    const updatedTheme = { ...themeOptions, ...newOptions };
    setThemeOptions(updatedTheme);
    localStorage.setItem("themeOptions", JSON.stringify(updatedTheme));
  };

  const theme = getTheme(themeOptions);

  const restoreDefaultTheme = () => {
    setThemeOptions(defaultTheme);
    localStorage.setItem("themeOptions", JSON.stringify(defaultTheme));
  };

  useEffect(() => {
    const storedTheme = JSON.parse(localStorage.getItem("themeOptions"));
    if (storedTheme) setThemeOptions(storedTheme);
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, themeOptions, updateTheme, restoreDefaultTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
